import { useSearch } from 'wouter'
import FicheProducteur from '../components/FicheProducteur'
import { useActionsPortail } from '../contexts/navigation'
import { useAuth } from '../AuthContext'
import { useCasquette } from '../contexts/casquette'

/**
 * Page publique d'un producteur — `/p/:id` (S62).
 *
 * C'est l'adresse que le producteur PARTAGE (WhatsApp, Facebook, QR code sur
 * son stand). Elle rend la MEME fiche que celle ouverte depuis un evenement :
 * une seule source, aucune divergence. Le serveur (`server.mjs`) injecte
 * l'en-tete Open Graph de cette fiche pour la carte de previsualisation.
 *
 * Retour : arriere navigateur si on vient d'ailleurs, sinon l'accueil (lien
 * ouvert directement). Prix masques hors contexte d'evenement (query `prix`).
 */
export default function PageProducteurPublic({ id }) {
  const { setHubTab, openMarche } = useActionsPortail()
  // Contexte d'evenement (ouverture depuis un marche) : ?prix=1 & ?stand=A12.
  // Sans query (lien partage), les prix restent masques — ils dependent du marche.
  const params = new URLSearchParams(useSearch())
  const afficherPrix = params.get('prix') === '1'
  const emplacement = params.get('stand') || undefined
  const { isAuthenticated } = useAuth()
  const { hubMode } = useCasquette()
  const retour = () => {
    if (window.history.length > 1) window.history.back()
    else setHubTab('home')
  }
  return (
    <FicheProducteur
      producteurId={id}
      eventAfficherPrix={afficherPrix}
      emplacement={emplacement}
      onClose={retour}
      // Visiteur ou client : ouvrir l'evenement ; producteur : rester (son module a sa propre entree)
      onExploreMarche={(marche) => { if (marche?.id && !(isAuthenticated && hubMode === 'producer')) openMarche(marche.id) }}
    />
  )
}
